var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPremiums(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M10 2.5c.847 0 1.69.127 2.5.375l-.481.144a.625.625 0 0 0-.394.731c.08.262.32.442.594.444.06.006.12.006.181 0l1.981-.625a.625.625 0 0 0 .413-.794L14.169.9a.625.625 0 0 0-.794-.344.625.625 0 0 0-.394.794l.132.381A9.844 9.844 0 0 0 10 1.25C4.775 1.25.525 5.256.525 10.206a8.619 8.619 0 0 0 1.575 5c.118.166.31.264.512.263a.575.575 0 0 0 .357-.113.625.625 0 0 0 .156-.9 7.35 7.35 0 0 1-1.35-4.25C1.775 5.944 5.462 2.5 10 2.5zm7.844 2.669a.625.625 0 1 0-1.013.725 7.394 7.394 0 0 1 1.394 4.312c0 4.269-3.688 7.738-8.225 7.738a8.625 8.625 0 0 1-3.313-.656l.275-.038a.625.625 0 1 0-.175-1.238l-2.05.307a.625.625 0 0 0-.418.25.625.625 0 0 0-.107.469l.313 1.918a.625.625 0 0 0 .625.519h.1a.625.625 0 0 0 .506-.725l-.094-.556a9.837 9.837 0 0 0 4.338 1c5.225 0 9.475-4.031 9.475-8.988 0-1.809-.57-3.572-1.631-5.037zM12.5 11.756c0-1.531-1.25-2.069-2.338-2.362-1.3-.35-1.412-.738-1.412-1.144 0-.575.45-.9 1.25-.906 1.081 0 1.219.556 1.25.656a.628.628 0 1 0 1.25-.113 2.063 2.063 0 0 0-1.875-1.743v-.832a.625.625 0 1 0-1.25 0v.838A2.1 2.1 0 0 0 7.5 8.256c0 1.525 1.25 2.056 2.338 2.35 1.3.35 1.412.75 1.412 1.156 0 .775-.775.894-1.25.894-1.075 0-1.25-.55-1.25-.668a.628.628 0 1 0-1.25.125 2.062 2.062 0 0 0 1.875 1.743v.832a.625.625 0 1 0 1.25 0v-.838a2.094 2.094 0 0 0 1.875-2.094z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F2F5",
    d: "M-1130-265H310V855h-1440z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#636176",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiums);
export default __webpack_public_path__ + "static/media/premiums.cafde4df39c88a1c1b18b9a84859981d.svg";
export { ForwardRef as ReactComponent };